<template>
    <div class="animated fadeIn">
        <b-row class="my-3">
            <b-col>
                <h4 class="text-center text-primary">
                    <i class="fa fa-file-text-o text-primary mr-2"></i>
                    Ficha de Recibo
                </h4>
            </b-col>
        </b-row>

        <b-row>
            <b-col>
                <b-card>
                    <div
                        v-if="!!receipt.code"
                        slot="header"
                        class="d-flex justify-content-between align-content-center animated fadeIn">
                        <b>{{receipt.code}}</b>
                        <span>{{receipt.getStatusName()}}</span>
                    </div>

                    <b-row>
                        <b-col col>
                            <b>Socio:</b>
                            <span>
                                <template v-if="!!receipt.member">
                                    {{receipt.member.fullName}}
                                </template>
                                <template v-else>
                                    -
                                </template>
                            </span>
                        </b-col>

                        <b-col col>
                            <b>Forma de Pago:</b>
                            <span>
                                <template v-if="!!statistics.paymentMethod">
                                    {{statistics.getPaymentMethodName()}}
                                </template>
                                <template v-else>
                                    -
                                </template>
                            </span>
                        </b-col>

                        <b-col col>
                            <b>Recibos Emitidos:</b>
                            <span>
                                <template v-if="!!statistics.numReceipts">
                                    {{statistics.numReceipts}}
                                </template>
                                <template v-else-if="statistics.numReceipts === 0">
                                    0
                                </template>
                                <template v-else>
                                    -
                                </template>
                            </span>
                        </b-col>
                    </b-row>

                    <b-row>
                        <b-col col>
                            <b>Código de Socio:</b>
                            <span>
                                <template v-if="!!receipt.member">
                                    {{receipt.member.code}}
                                </template>
                                <template v-else>
                                    -
                                </template>
                            </span>
                        </b-col>

                        <b-col col>
                            <b>Tipo de Cuota:</b>
                            <span>
                                <template v-if="!!statistics.periodicity">
                                    {{statistics.getPeriodicityName()}}
                                </template>
                                <template v-else>
                                    -
                                </template>
                            </span>
                        </b-col>

                        <b-col col>
                            <b>Recibos Cobrados:</b>
                            <span>
                                <template v-if="!!statistics.numReceiptsCharged">
                                    {{statistics.numReceiptsCharged}}
                                </template>
                                <template v-else-if="statistics.numReceiptsCharged === 0">
                                    0
                                </template>
                                <template v-else>
                                    -
                                </template>
                            </span>
                        </b-col>
                    </b-row>

                    <b-row>
                        <b-col col>
                            <b>Socio desde:</b>
                            <span>
                                <template v-if="!!statistics.createdAt">
                                    {{statistics.createdAt | dateFormat('DD/MM/YYYY')}}
                                </template>
                                <template v-else>
                                    -
                                </template>
                            </span>
                        </b-col>

                        <b-col col>
                            <b>Cantidad:</b>
                            <span>
                                <template v-if="!!statistics.feeAmount">
                                    {{statistics.feeAmount}}€
                                </template>
                                <template v-else>
                                    -
                                </template>
                            </span>
                        </b-col>

                        <b-col col>
                            <b>Recibos Tratados:</b>
                            <span>
                                <template v-if="!!statistics.numReceiptsTreated">
                                    {{statistics.numReceiptsTreated}}
                                </template>
                                <template v-else-if="statistics.numReceiptsTreated === 0">
                                    0
                                </template>
                                <template v-else>
                                    -
                                </template>
                            </span>
                        </b-col>
                    </b-row>

                    <b-row align-h="between">
                        <b-col cols="4">
                            <b>Último Recibo Pagado:</b>
                            <span>
                                <template v-if="!!statistics.lastReceiptChargedDate">
                                    {{statistics.lastReceiptChargedDate | dateFormat('DD/MM/YYYY')}}
                                </template>
                                <template v-else>
                                    -
                                </template>
                            </span>
                        </b-col>

                        <b-col cols="4">
                            <b>Recibos Anulados:</b>
                            <span>
                                <template v-if="!!statistics.numReceiptsCanceled">
                                    {{statistics.numReceiptsCanceled}}
                                </template>
                                <template v-else-if="statistics.numReceiptsCanceled === 0">
                                    0
                                </template>
                                <template v-else>
                                    -
                                </template>
                            </span>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col class="d-flex flex-row justify-content-end">
                            <div v-if="receipt.status === 'CANCELED' || receipt.status === 'CHARGE_BY_BANK'">
                                <button class="btn btn-brand btn-primary btn-md" @click="changeReceiptStatusReturned()">
                                    Volver a estado anterior
                                </button>
                            </div>
                        </b-col>
                    </b-row>
                </b-card>
            </b-col>
        </b-row>

        <b-row>
            <b-col cols="6">
                <b-row v-if="receipt.isEditable()" class="animated fadeIn">
                    <b-col>
                        <b-card>
                            <div slot="header">
                                Tratamiento
                            </div>

                            <receipt-actions
                                v-model="receipt"
                                class="p-0"
                                @receipt-refresh-required="getReceipt(receipt.uuid)"></receipt-actions>
                        </b-card>
                    </b-col>
                </b-row>

                <b-row>
                    <b-col>
                        <b-card>
                            <div slot="header">
                                Historial del Recibo
                            </div>

                            <b-container>
                                <b-row>
                                    <b-col>
                                        <template v-if="mementos.items.length">
                                            <b-table
                                                small
                                                fixed
                                                striped
                                                :fields="mementos.fields"
                                                :items="mementos.items">
                                                <template slot="user" slot-scope="data">
                                                    <template v-if="!!data.value">{{data.value.fullName}}</template>
                                                    <template v-else>-</template>
                                                </template>

                                                <template slot="date" slot-scope="data">
                                                    {{data.value | dateFormat('DD/MM/YYYY HH:mm')}}
                                                </template>

                                                <template slot="text" slot-scope="data">
                                                    <template v-if="!!data.item.text">{{data.item.text}}</template>
                                                    <template v-else>{{data.item.getStatusName()}}</template>
                                                </template>
                                            </b-table>
                                        </template>

                                        <template v-else>No hay historial</template>
                                    </b-col>
                                </b-row>
                            </b-container>
                        </b-card>
                    </b-col>
                </b-row>
            </b-col>

            <b-col cols="6">
                <b-card>
                    <div slot="header" class="d-flex justify-content-between align-content-center">
                        <div>
                            Notas del Socio
                        </div>
                        <div>
                            <i class="fa fa-plus" @click="newNote=true"></i>
                        </div>
                    </div>

                    <client-notes-management
                        :client-id="receipt.member.uuid"
                        :show-note-form="newNote"
                        @note-form-closed="newNote=false"></client-notes-management>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>

<script>
    import {getReceipt, getReceiptMementos, changeReceiptReturned} from '@/api/receipt-api';
    import {getMemberReceiptsStatistics} from '@/api/statistics-api';
    import receiptActions from '@/views/accounting/Receipts/ReceiptActions';
    import clientNotesManagement from '@/components/clients/notes/ClientNotesManagement';

    export default {
        name: "EditReceipt",
        components: {
            receiptActions,
            clientNotesManagement
        },
        data: function () {
            return {
                prevRoute: null,
                topMenu: [],
                receipt: {
                    uuid: null,
                    member: {
                        uuid: null
                    }
                },
                newNote: false,
                statistics: {
                    uuid: null
                },
                mementos: {
                    items: [],
                    fields: [
                        {key: 'user', label: 'Usuario'},
                        {key: 'date', label: 'Fecha'},
                        {key: 'text', label: 'Acción'}
                    ]
                }
            }
        },
        beforeRouteEnter(to, from, next) {
            next(vm => {
                vm.prevRoute = from
            })
        },
        mounted() {
            if (!this.$route.params.uuid) {
                this.$router.push({path: '/accounting/consignments/list'});
            }
            this.$eventHub.$emit('captureMenu', this.topMenu);
            this.getReceipt(this.$route.params.uuid);
        },
        computed: {
            receiptHasActions() {
                return (
                    !!this.receipt.uuid
                    && !this.receipt.isCreatedStatus()
                    && (
                        this.receipt.isCollectorType()
                        || this.receipt.isReceiptType()
                        || (this.receipt.isBankType() && !this.receipt.isChargedStatus())
                    )
                );
            }
        },
        methods: {
            async getReceipt(receiptId) {
                this.$_loadingMixin_showLoading();
                await getReceipt(receiptId)
                    .then((receipt) => {
                        if (!this.receipt.uuid) {
                            let consignmentRoute = this.$router.resolve({
                                name: 'consignmentOverview',
                                params: {uuid: receipt.consignment.uuid},
                            });
                            this.topMenu.push({
                                name: 'Remesa',
                                path: consignmentRoute.href.replace(/^#/g, ''),
                                brand: 'fa fa-industry'
                            });
                            let memberRoute = this.$router.resolve({
                                name: 'editPartner',
                                params: {uuid: receipt.member.uuid},
                            });
                            this.topMenu.push({
                                name: 'Socio',
                                path: memberRoute.href.replace(/^#/g, ''),
                                brand: 'fa fa-user'
                            });
                        }

                        this.receipt = receipt;
                    });
                this.$_loadingMixin_hideLoading();
            },
            async changeReceiptStatusReturned() {
                try {
                    this.$_loadingMixin_showLoading();
                    const receiptId = this.receipt.uuid;
                    if (receiptId) {
                        await changeReceiptReturned(receiptId);
                        this.$_notificationMixin_success('Operación completada', 'El recibo paso a estado "Devuelto"');
                        this.$_loadingMixin_hideLoading();
                    } else {
                        this.$_notificationMixin_error('Error en la operación', 'El recibo es vacio.');
                        this.$_loadingMixin_hideLoading();
                    }
                } catch (error) {
                    this.$_notificationMixin_error('Error en la operación', 'No se ha podido cambiar a estado "Devuelto"');
                    this.$_loadingMixin_hideLoading();
                }
            },
            async getMemberReceiptsStatistics(memberId) {
                this.$_loadingMixin_showLoading();
                await getMemberReceiptsStatistics(memberId)
                    .then((statistics) => {
                        this.statistics = statistics;
                    });
                this.$_loadingMixin_hideLoading();
            },
            async getReceiptMementos(receiptId) {
                this.$_loadingMixin_showLoading();
                await getReceiptMementos(receiptId)
                    .then((mementos) => {
                        this.mementos.items = mementos;
                    });
                this.$_loadingMixin_hideLoading();
            }
        },
        watch: {
            prevRoute: function () {
                if (!!this.prevRoute && !!this.prevRoute.path) {
                    this.topMenu.push({
                        name: 'Volver',
                        path: this.prevRoute.path,
                        brand: 'fa fa-arrow-left'
                    });
                }
            },
            topMenu: function () {
                this.$eventHub.$emit('captureMenu', this.topMenu);
            },
            receipt: function () {
                if (!!this.receipt.member && !!this.receipt.member.uuid) {
                    this.getMemberReceiptsStatistics(this.receipt.member.uuid);
                }
                if (!!this.receipt.uuid) {
                    this.getReceiptMementos(this.receipt.uuid);
                }
            }
        }
    }
</script>

<style scoped>
</style>